import BaseAPI from "./apiBase";

export async function fetchDailyHusbandryRoomReportData(params) {
    const result = await BaseAPI.simpleGetAsync("/dailyhusbandry/husbandryroomreportdata", { params: params });

    return result.data;
}

export async function fetchDailyHusbandryMedicalObservation(params) {
    const result = await BaseAPI.simpleGetAsync("/dailyhusbandry/medicalobservation", { params: params });

    return result.data;
}